import { render, staticRenderFns } from "./LinhaAssistenteDialog.vue?vue&type=template&id=04e3a1fe&scoped=true&"
import script from "./LinhaAssistenteDialog.vue?vue&type=script&lang=js&"
export * from "./LinhaAssistenteDialog.vue?vue&type=script&lang=js&"
import style0 from "./LinhaAssistenteDialog.vue?vue&type=style&index=0&id=04e3a1fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e3a1fe",
  null
  
)

export default component.exports